import { isFretboardInstrument } from "./instrumentEngine";
import type { InstrumentType } from "./instrumentEngine";
import type { NeckPosition, NoteName } from "./guitarEngine";
import { getNoteAtPosition } from "./guitarEngine";
import { getNoteAtPositionInstrument } from "./instrumentEngine";
import type { PianoFingeredKey } from "./pianoFingeringEngine";
import { clampFinger } from "./practiceNoteModel";

export type PracticeSurface = "fretboard" | "keyboard";

export function getPracticeSurface(instrument: InstrumentType): PracticeSurface {
  return instrument === "piano" || instrument === "melodica" ? "keyboard" : "fretboard";
}

/** Convierte posiciones de mástil a teclas resaltadas en piano. */
export function neckPositionsToKeyboardFingering(
  positions: NeckPosition[],
  fretInstrument: "guitar" | "ukulele" = "guitar"
): PianoFingeredKey[] {
  const seen = new Set<number>();
  const out: PianoFingeredKey[] = [];
  for (const p of positions) {
    const { midi } = getNoteAtPositionInstrument(p.string, p.fret, fretInstrument);
    if (seen.has(midi)) continue;
    seen.add(midi);
    const finger = p.finger != null && p.finger >= 1 && p.finger <= 5 ? (p.finger as 1 | 2 | 3 | 4 | 5) : clampFinger(1);
    out.push({
      midi,
      finger,
      hand: p.hand === "right" ? "R" : "L",
      degree: String(p.degree ?? ""),
      step: p.note,
    });
  }
  return out.sort((a, b) => a.midi - b.midi);
}

export function activeNoteToMidi(
  active: { string: number; fret: number } | null | undefined,
  fretInstrument: "guitar" | "ukulele" = "guitar"
): number | null {
  if (!active) return null;
  return getNoteAtPositionInstrument(active.string, active.fret, fretInstrument).midi;
}

export function findNeckPositionForMidi(
  positions: NeckPosition[],
  midi: number,
  fretInstrument: "guitar" | "ukulele" = "guitar"
): NeckPosition | undefined {
  return positions.find((p) => {
    const m = getNoteAtPositionInstrument(p.string, p.fret, fretInstrument).midi;
    return m === midi;
  });
}

export function midiToNoteAtPosition(midi: number): { string: number; fret: number; note: NoteName } {
  for (let s = 6; s >= 1; s--) {
    for (let f = 0; f <= 15; f++) {
      const p = getNoteAtPosition(s, f);
      if (p.midi === midi) return { string: s, fret: f, note: p.note };
    }
  }
  const names = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"] as const;
  const pc = ((midi % 12) + 12) % 12;
  return { string: 1, fret: 0, note: names[pc] as NoteName };
}
